import React from 'react';
import { useTranslation } from 'react-i18next';
import ClarifiersImg from '../../assets/images/CHIARIFICANTI_bordo_3.png'
import './Clarifiers.css'



function Clarifiers() {
  const { t } = useTranslation();

  const products = [
   
    {
        name: t('ICEclarALBUMINA DRY'),
        description: t('Albumin powder.'),
      },
      {
        name: t('ICEclar BENT G'),
        description: t('Activated granular bentonite.'),
      },
      {
        name: t('ICEclar BIANCHI'),
        description: t('Complex allergen-free clarifying agent designed for the treatment of white wines. It is particularly effective against oxidized catechins and flavonoids. The formulation improves the protein stability of wines and filterability by causing reduced and compact sediments. Its composition ensures a valid alternative to the traditional fining agents used, guaranteeing greater longevity in the wines obtained and an improvement in the sensorial picture.'),
      },
      {
        name: t('ICEclar FISH GEL'),
        description: t('Fish gellatine.'),
      },
      {
        name: t('ICEclar GELATINA 50 L'),
        description: t('Liquid gelatin 50%.'),
      },
      {
        name: t('ICEclar PVPP'),
        description: t('Polivinilpolipirrolidone.'),
      },
      {
        name: t('ICEclar GELATINA DRY'),
        description: t('Gelatin powder.'),
      },
      {
        name: t('ICEclar ROSSI'),
        description: t('Complex allergen-free clarifying agent designed for the treatment of red wines. Its composition ensures a valid alternative to the traditional protein clarifying agents used, guaranteeing a reduction in bitter tannins and astringency in general, providing roundness.'),
      },
     
      {
        name: t('ICEclar Fenol STOP'),
        description: t('Adjuvant designed for the treatment of wines presenting olfactory deviations caused by unwanted microbiological activities. With its selective adsorbent action towards 4-Ethyl phenol and 4-Ethyl guaiacol it guarantees rapid action in the treatmentand limited color loss. It allows you to obtain a more compact deposit compared to other carbons, facilitating the filtration of the wine.'),
      },
     
      {
        name: t('ICEclar K'),
        description: t('Clarifier based on potassium caseinate.'),
      },
     
     
  
  ];

  return (
  <>

<div className='mainClarifiersImg'>
  <div className='ClarifiersImg1'></div>

  <div className="ClarifiersImg2">
    <h1 className="ClarifiersTitle">{t('Clarifiers')}</h1>
    <img src={ClarifiersImg} alt="Clarifiers" />
  </div>
</div>

    <div className="main-infocontainer">
      {products.map((product, index) => (
        <div className="item-container" key={index}>
          {/* <img src={product.image} alt={product.name} /> */}
          <div className="text-info">
            <h1>{product.name}</h1>
            <p>{product.description}</p>
          </div>
        </div>
      ))}
    </div>
    </>
  );
}

export default Clarifiers;
